import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function WasteManifests() {
  const { data, siteNames } = useHSE();
  const rows = data.wasteManifests || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/waste-manifests", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `wm-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Total Waste Manifests" value={rows.length} testid="wm-total" />
      <StatCard label="Hazardous Waste" value={rows.filter((r) => r.wasteCategory === "hazardous").length} tone="critical" />
      <StatCard label="In Transit" value={rows.filter((r) => r.custodyStatus === "in_transit").length} tone="warning" />
      <StatCard label="Disposed & Certified" value={rows.filter((r) => r.custodyStatus === "disposed").length} tone="safe" />
      <StatCard label="Generated" value={rows.filter((r) => r.custodyStatus === "generated").length} tone="info" />
    </div>
  );

  return (
    <RegisterPage
      title="Waste Manifests & Chain of Custody"
      subtitle="Hazardous & Non-Hazardous Waste Consignment Manifests, License Tracking & Disposal Certification"
      storeKey="wasteManifests"
      idPrefix="WM"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "WM ID" },
        { key: "manifestNo", label: "Manifest No" },
        { key: "wasteCategory", label: "Category", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.wasteCategory === "hazardous" ? "bg-rose-100 text-rose-800" : "bg-blue-100 text-blue-800"}`}>{r.wasteCategory || "hazardous"}</span> },
        { key: "wasteType", label: "Waste Type" },
        { key: "quantity", label: "Quantity", render: (r) => <span className="font-mono font-bold">{r.quantity} {r.quantityUnit}</span> },
        { key: "transporterName", label: "Licensed Transporter" },
        { key: "destinationFacility", label: "Destination Facility" },
        { key: "custodyStatus", label: "Custody Status", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.custodyStatus === "disposed" ? "bg-emerald-100 text-emerald-800" : r.custodyStatus === "in_transit" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-700"}`}>{r.custodyStatus || "generated"}</span> },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "WM ID" },
        { key: "manifestNo", label: "Consignment Manifest Number" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "wasteCategory", label: "Category", type: "select", options: ["hazardous", "non_hazardous", "medical", "e_waste"] },
        { key: "wasteType", label: "Waste Type / Description" },
        { key: "quantity", label: "Quantity", type: "number" },
        { key: "quantityUnit", label: "Unit", type: "select", options: ["kg", "ton", "liters", "drums"] },
        { key: "transporterName", label: "Transporter Company Name" },
        { key: "transporterLicense", label: "Transporter Environmental Permit No" },
        { key: "destinationFacility", label: "Approved Disposal / Recycling Facility" },
        { key: "disposalCertificateRef", label: "Disposal Certificate External Ref" },
        { key: "custodyStatus", label: "Chain of Custody Status", type: "select", options: ["generated", "in_transit", "received", "disposed"] },
      ]}
    />
  );
}
